import React, { ReactElement } from 'react';
import ChartBar from '../../../components/chart-bar/chart-bar.component';
import Widget from '../../../components/widget/widget.component';
import useScreenMedium from '../../../hooks/use-screen-medium';
import useScreenMobile from '../../../hooks/use-screen-mobile';
import { WIDGET_NAME_DEAL_SOURCES_BY_BROKER } from '../../../constants/system/widget-names';

const DashboardWidgetDealSourcesByBroker: ReactMemoComponent = React.memo((
  props: ReactComponentProps,
): ReactElement => {
  const WIDGET_CHART_BAR_ELEMENT_LIMIT_DEFAULT: number = 5;
  const WIDGET_CHART_BAR_ELEMENT_LIMIT_MEDIUM: number = 4;
  const WIDGET_CHART_BAR_ELEMENT_LIMIT_SMALL: number = 3;
  const ID_CONTAINER_CHART_DEAL_SOURCES_BY_BROKER: string = 'container-chart-deal-sources-by-broker';
  const WIDGET_TITLE_DEFAULT: string = 'Sources of Deals by Broker';

  const {
    contactListData,
    widgetSettings,
    onWidgetSettingsChange,
  } = props;

  const isMediumScreen: boolean = useScreenMedium();
  const isMobileScreen: boolean = useScreenMobile();

  const chartBarItemsLimit: number = isMobileScreen ? WIDGET_CHART_BAR_ELEMENT_LIMIT_SMALL
    : ((isMediumScreen && WIDGET_CHART_BAR_ELEMENT_LIMIT_MEDIUM) || WIDGET_CHART_BAR_ELEMENT_LIMIT_DEFAULT);
  const chartItemList: ChartBarItem[] = contactListData && contactListData.length
    ? contactListData.map((contactItem: Contact): ChartBarItem => ({
      name: contactItem.fullName,
      value: contactItem.dealsTotal || 0,
    })) : [];

  return (
    <Widget
      withCustomizeMode
      isEmpty={!contactListData || !contactListData.length}
      widgetName={WIDGET_NAME_DEAL_SOURCES_BY_BROKER}
      defaultWidgetTitle={WIDGET_TITLE_DEFAULT}
      widgetSettings={widgetSettings}
      onWidgetSettingsChange={onWidgetSettingsChange}
    >
      <ChartBar
        containerId={ID_CONTAINER_CHART_DEAL_SOURCES_BY_BROKER}
        chartItemList={chartItemList}
        chartItemsLimit={chartBarItemsLimit}
      />
    </Widget>
  );
});

export default DashboardWidgetDealSourcesByBroker;
